/* IZY Equip theme – storefront behaviour (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const J = (id) => { try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; } };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };

  const I = J('izy-i18n') || { lang: 'fr', spec: {}, short: {}, cat: {}, catS: {} };
  const L = I.lang === 'en' ? 'en' : 'fr';
  const DB = J('izy-db') || {};
  const PR = (J('izy-products') || []).map((p) => (p ? Object.assign(p, { d: DB[p.h] || null }) : p)).filter((p) => p && p.d);
  const byH = (h) => PR.find((p) => p.h === h);
  const label = (p) => p.d.code + (p.d.sub ? ' · ' + p.d.sub[L] : '');
  const V = (v) => (v && typeof v === 'object' ? v[L] : v);
  const ORDER = 'w,prod,dehum,cfm,brush,main,side,press,bm,vacm,vac,sq,tanks,tank,hop,filt,filt2,bat,run,chg,chgr,tm,drive,speed,grade,turn,dim,wt,db,scr,conn,wtn,pwr,spd,rpm,throw,air,volt,cord,size,cap,wtu,fits'.split(',');
  const specVal = (s) => (s[L] === '✓' ? I.yes : s[L]);

  /* ---------- header: mega menu, drawer, search ---------- */
  const mega = $('#izy-mega');
  if (mega) {
    const btn = mega.querySelector('button');
    const hoverable = () => matchMedia('(hover:hover) and (pointer:fine)').matches;
    let closeT = null;
    const setOpen = (o) => { clearTimeout(closeT); mega.classList.toggle('open', o); btn.setAttribute('aria-expanded', o); };
    // with a mouse, clicking "Catalogue" keeps the menu open; on touch screens it toggles
    btn.addEventListener('click', (e) => { e.stopPropagation(); setOpen(hoverable() ? true : !mega.classList.contains('open')); });
    mega.addEventListener('mouseenter', () => { if (hoverable()) setOpen(true); });
    // small delay so moving the mouse from the button to the panel never closes it
    mega.addEventListener('mouseleave', () => { if (!hoverable()) return; clearTimeout(closeT); closeT = setTimeout(() => setOpen(false), 350); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && mega.classList.contains('open')) { setOpen(false); btn.focus(); } });
    document.addEventListener('click', (e) => { if (!e.target.closest('#izy-mega')) { mega.classList.remove('open'); btn.setAttribute('aria-expanded', false); } });
  }
  const drawer = $('#izy-drawer'), burger = $('#izy-burger'), search = $('#izy-search'), sbtn = $('#izy-search-btn'), q = $('#izy-q'), qres = $('#izy-q-res');
  const closeAll = () => {
    drawer && drawer.classList.remove('open'); burger && burger.setAttribute('aria-expanded', 'false');
    search && search.classList.remove('open'); sbtn && sbtn.setAttribute('aria-expanded', 'false');
    mega && mega.classList.remove('open');
  };
  burger && burger.addEventListener('click', () => { const o = drawer.classList.toggle('open'); burger.setAttribute('aria-expanded', o); search.classList.remove('open'); });
  sbtn && sbtn.addEventListener('click', () => {
    const o = search.classList.toggle('open'); sbtn.setAttribute('aria-expanded', o); drawer && drawer.classList.remove('open');
    if (o) { q.value = ''; qres.innerHTML = ''; q.focus(); }
  });
  q && q.addEventListener('input', () => {
    const t = q.value.trim().toLowerCase();
    const list = t ? PR.filter((p) => (label(p) + ' ' + p.d.name.fr + ' ' + p.d.name.en + ' ' + (I.cat[p.d.fam] || '')).toLowerCase().includes(t)).slice(0, 8) : [];
    qres.innerHTML = list.map((p) => `<li><a href="${esc(p.u)}"><span class="c">${esc(label(p))}</span><span>${esc(p.d.name[L])}</span><span class="k">${esc(I.catS[p.d.fam] || '')}</span></a></li>`).join('');
  });
  q && q.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { const a = qres.querySelector('a'); if (a) { e.preventDefault(); location.href = a.href; } }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- width ruler ---------- */
  const ruler = $('#izy-ruler');
  if (ruler) {
    const rin = ruler.querySelector('.rin'), min = +ruler.dataset.min || 12, max = +ruler.dataset.max || 64;
    const pos = (w) => (((w - min) / (max - min)) * 100).toFixed(2);
    const on = PR.filter((p) => p.d.w && ['walk', 'ride', 'sweep'].includes(p.d.fam)).sort((a, b) => a.d.w - b.d.w);
    const lv = {};
    on.forEach((p) => { let l = 0; while (on.some((q2) => q2 !== p && lv[q2.h] === l && Math.abs(q2.d.w - p.d.w) < 3.6)) l++; lv[p.h] = l; });
    let html = '';
    for (let w = min; w <= max; w++) {
      const maj = w % 4 === 0;
      html += `<i class="tick ${maj ? 'maj' : 'min'}" style="left:${pos(w)}%"></i>` + (maj ? `<span class="tlab" style="left:${pos(w)}%">${w}″</span>` : '');
    }
    html += on.map((p) => `<a class="pin ${p.d.fam}" href="${esc(p.u)}" data-pin="${esc(p.h)}" style="left:${pos(p.d.w)}%"><span>${esc(p.d.code.replace('IZY-', ''))}</span><i style="height:${14 + lv[p.h] * 34}px"></i></a>`).join('');
    rin.innerHTML = html;
    const ro = $('#izy-readout');
    const read = (pin) => {
      const p = byH(pin.dataset.pin); if (!p) return;
      const w = (p.d.specs || []).find((s) => s.k === 'w');
      $$('.pin', ruler).forEach((b) => b.classList.toggle('hot', b === pin));
      ro.innerHTML = `<b>${esc(label(p))}</b><span>${esc(p.d.name[L])}</span>${w ? `<span class="k">${esc(I.spec.w)} ${esc(w[L])}</span>` : ''}`;
    };
    ruler.addEventListener('pointerover', (e) => { const pin = e.target.closest('[data-pin]'); if (pin) read(pin); });
    ruler.addEventListener('focusin', (e) => { const pin = e.target.closest('[data-pin]'); if (pin) read(pin); });
  }

  /* ---------- catalogue filters ---------- */
  const cat = $('#izy-catalogue');
  if (cat) {
    const grid = $('#izy-grid'), empty = $('#izy-empty'), title = $('#izy-cat-title'), sub = $('#izy-cat-sub');
    const baseTitle = title.textContent, baseSub = sub.textContent;
    const params = new URLSearchParams(location.search);
    const F = { cat: params.get('famille') || 'all', w: 'any', q: '', sort: 'w' };
    if (!$(`[data-fcat="${CSS.escape(F.cat)}"]`, cat)) F.cat = 'all';
    const cards = $$('.izy-card', grid);
    cards.forEach((c, i) => (c.dataset.i = i));
    const apply = (push) => {
      const t = F.q.trim().toLowerCase();
      let shown = 0;
      cards.forEach((c) => {
        const w = +c.dataset.w;
        const ok = (F.cat === 'all' || c.dataset.fam === F.cat)
          && (F.w === 'any' || (w && (F.w === 's' ? w < 20 : F.w === 'm' ? w >= 20 && w <= 34 : w > 34)))
          && (!t || c.dataset.q.includes(t));
        c.hidden = !ok; if (ok) shown++;
      });
      const sorted = [...cards].sort((a, b) => {
        if (F.sort === 'n') return a.dataset.code.localeCompare(b.dataset.code);
        const wa = +a.dataset.w || 99, wb = +b.dataset.w || 99;
        return F.sort === 'wd' ? (+b.dataset.w || 0) - (+a.dataset.w || 0) : wa - wb || a.dataset.i - b.dataset.i;
      });
      sorted.forEach((c) => grid.appendChild(c));
      empty.hidden = shown > 0;
      $$('[data-fcat]', cat).forEach((b) => b.setAttribute('aria-pressed', b.dataset.fcat === F.cat));
      $$('[data-fw]', cat).forEach((b) => b.setAttribute('aria-pressed', b.dataset.fw === F.w));
      const fb = $(`[data-fcat="${CSS.escape(F.cat)}"]`, cat);
      title.textContent = F.cat === 'all' ? baseTitle : fb.dataset.title;
      sub.textContent = F.cat === 'all' ? baseSub : fb.dataset.sub;
      if (push) {
        const u = new URL(location.href);
        if (F.cat === 'all') u.searchParams.delete('famille'); else u.searchParams.set('famille', F.cat);
        history.replaceState(null, '', u);
      }
    };
    cat.addEventListener('click', (e) => {
      const fc = e.target.closest('[data-fcat]'); if (fc && !fc.disabled) { F.cat = fc.dataset.fcat; apply(true); return; }
      const fw = e.target.closest('[data-fw]'); if (fw) { F.w = fw.dataset.fw; apply(); return; }
      if (e.target.closest('#izy-freset')) { F.cat = 'all'; F.w = 'any'; F.q = ''; $('#izy-fq').value = ''; apply(true); }
    });
    $('#izy-fq').addEventListener('input', (e) => { F.q = e.target.value; apply(); });
    $('#izy-fsort').addEventListener('change', (e) => { F.sort = e.target.value; apply(); });
    apply(false);
  }

  /* ---------- compare ---------- */
  let cmp = store.get('izy-cmp', []).filter((h) => byH(h));
  const tray = $('#izy-tray');
  const isComparePage = !!$('#izy-compare');
  const syncButtons = () => $$('[data-cmp]').forEach((b) => { const on = cmp.includes(b.dataset.cmp); b.setAttribute('aria-pressed', on); b.textContent = on ? I.cmpOn : I.cmpAdd; });
  const renderTray = () => {
    if (!tray) return;
    tray.classList.toggle('show', cmp.length > 0 && !isComparePage);
    tray.firstElementChild.innerHTML = `<span class="eyebrow" style="color:var(--plate-mute)">${esc(I.cmpTitle)}</span><div class="items">${cmp.map((h) => `<span class="it">${esc(label(byH(h)))}<button type="button" data-rm="${esc(h)}" aria-label="${esc(I.cmpRm)} ${esc(label(byH(h)))}">×</button></span>`).join('')}${cmp.length >= 3 ? `<span style="font-size:12px;color:var(--plate-mute);align-self:center">${esc(I.cmpMax)}</span>` : ''}</div><button type="button" class="clear" id="izy-cmp-clear">${esc(I.cmpClear)}</button><a class="btn sm" href="${esc(I.compareUrl)}">${esc(I.cmpGo)} (${cmp.length}) →</a>`;
  };
  const renderCompare = () => {
    const box = $('#izy-compare'); if (!box) return;
    const list = cmp.map(byH).filter(Boolean);
    if (!list.length) return; /* keep the server-rendered empty state */
    const keys = ORDER.filter((k) => list.some((p) => (p.d.specs || []).some((s) => s.k === k)));
    const val = (p, k) => { const s = (p.d.specs || []).find((x) => x.k === k); return s ? esc(specVal(s)) : '—'; };
    box.innerHTML = `<div class="cmp-wrap"><table class="cmpt">
      <tr><th></th>${list.map((p) => `<td class="phc"><div class="ph">${p.img ? `<img src="${esc(p.img)}" alt="${esc(label(p))}" loading="lazy">` : ''}</div></td>`).join('')}</tr>
      <tr><th>${esc(I.catalogue)}</th>${list.map((p) => `<td><a href="${esc(p.u)}" style="text-decoration:none"><span class="code">${esc(label(p))}</span><div class="nm">${esc(p.d.name[L])}</div></a><button type="button" class="rm" data-rm="${esc(p.h)}">${esc(I.cmpRm)}</button></td>`).join('')}</tr>
      ${keys.map((k) => `<tr><th>${esc(I.spec[k] || k)}</th>${list.map((p) => `<td>${val(p, k)}</td>`).join('')}</tr>`).join('')}
    </table></div>`;
  };
  const setCmp = (h) => {
    const i = cmp.indexOf(h);
    if (i >= 0) cmp.splice(i, 1); else { if (cmp.length >= 3) cmp.shift(); cmp.push(h); }
    store.set('izy-cmp', cmp); syncButtons(); renderTray();
    if (isComparePage) { if (cmp.length) renderCompare(); else location.reload(); }
  };

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-cmp],[data-rm],[data-thumb],[data-join],[data-region],#izy-cmp-clear,#izy-copy-mail');
    if (!el) return;
    if (el.dataset.cmp) { e.preventDefault(); setCmp(el.dataset.cmp); }
    else if (el.dataset.rm) { setCmp(el.dataset.rm); }
    else if (el.dataset.thumb) {
      const t = document.getElementById(el.dataset.target); if (!t) return;
      t.innerHTML = `<img src="${esc(el.dataset.thumb)}" alt="${esc(el.dataset.alt || '')}">`;
      el.parentElement.querySelectorAll('button').forEach((b) => b.setAttribute('aria-pressed', b === el));
    }
    else if (el.dataset.join) {
      const sel = $('#r-country'); if (!sel) return;
      e.preventDefault();
      const opt = [...sel.options].find((o) => o.dataset.r === el.dataset.join); if (opt) sel.value = opt.value;
      $('#join').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      setTimeout(() => { const c = $('#r-co'); c && c.focus({ preventScroll: true }); }, 450);
    }
    else if (el.dataset.region) {
      const sel = $('#d-region'); if (!sel) return;
      e.preventDefault();
      const opt = [...sel.options].find((o) => o.dataset.r === el.dataset.region); if (opt) sel.value = opt.value;
      $('#apply').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      setTimeout(() => { const c = $('#d-co'); c && c.focus({ preventScroll: true }); }, 450);
    }
    else if (el.id === 'izy-cmp-clear') { cmp = []; store.set('izy-cmp', cmp); syncButtons(); renderTray(); }
    else if (el.id === 'izy-copy-mail') {
      const mail = $('#izy-mail').textContent.trim();
      const done = () => { el.textContent = I.copied; setTimeout(() => (el.textContent = I.copy), 1500); };
      const sel = () => { const r = document.createRange(); r.selectNodeContents($('#izy-mail')); const s = getSelection(); s.removeAllRanges(); s.addRange(r); };
      try { navigator.clipboard.writeText(mail).then(done, () => { sel(); done(); }); } catch (err) { sel(); done(); }
    }
  });

  /* ---------- repair shops: country tabs + filter ---------- */
  const rep = $('#izy-repairs');
  if (rep) {
    const shops = $$('.shop', rep), bar = $('#izy-r-bar'), empty = $('#izy-r-empty'), noq = $('#izy-r-noq'), rq = $('#izy-r-q');
    const tabs = $$('[data-rc]', rep), rp = $('#izy-r-prov'), rpw = $('#izy-r-provw');
    const qs = new URLSearchParams(location.search);
    let rc = qs.get('pays');
    if (!tabs.some((b) => b.dataset.rc === rc)) rc = 'ca';
    const p0 = (qs.get('prov') || '').toUpperCase();
    if (rp && [...rp.options].some((o) => o.value === p0)) rp.value = p0;
    const apply = () => {
      const t = (rq.value || '').trim().toLowerCase();
      const pv = rc === 'ca' && rp ? rp.value : '';
      if (rpw) rpw.hidden = rc !== 'ca';
      const inC = shops.filter((s) => s.dataset.c === rc);
      let shown = 0;
      shops.forEach((s) => {
        const ok = s.dataset.c === rc && (!t || s.dataset.q.includes(t)) && (!pv || (s.dataset.p || '').split(',').includes(pv));
        s.hidden = !ok; if (ok) shown++;
      });
      tabs.forEach((b) => b.setAttribute('aria-selected', b.dataset.rc === rc));
      bar.hidden = inC.length === 0;
      empty.hidden = inC.length > 0;
      empty.querySelector('[data-join]').dataset.join = rc;
      noq.hidden = !(inC.length > 0 && shown === 0);
    };
    rep.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rc]');
      if (b) { rc = b.dataset.rc; const u = new URL(location.href); u.searchParams.set('pays', rc); history.replaceState(null, '', u); apply(); }
    });
    rq.addEventListener('input', apply);
    rp && rp.addEventListener('change', () => { const u = new URL(location.href); rp.value ? u.searchParams.set('prov', rp.value) : u.searchParams.delete('prov'); history.replaceState(null, '', u); apply(); });
    apply();
  }

  /* ---------- support: find your model ---------- */
  const sq = $('#izy-sq');
  sq && sq.addEventListener('input', () => {
    const t = sq.value.trim().toLowerCase().replace(/^izy-?/, '');
    $$('.drow').forEach((r) => (r.hidden = !!t && !r.dataset.k.includes(t)));
    $$('.dgroup').forEach((g) => (g.hidden = ![...g.querySelectorAll('.drow')].some((r) => !r.hidden)));
  });

  /* ---------- contact: prefill from ?model= ---------- */
  const model = new URLSearchParams(location.search).get('model');
  const cm = $('#c-model');
  if (model && cm) {
    if (![...cm.options].some((o) => o.value === model)) cm.add(new Option(model, model));
    cm.value = model;
    const msg = $('#c-msg'); if (msg && !msg.value) msg.value = (I.quoteMsg || '').replace('%MODEL%', model);
  }
  if ($('#apply') && location.hash === '#apply') setTimeout(() => $('#apply').scrollIntoView({ block: 'start' }), 60);

  syncButtons(); renderTray(); renderCompare();
})();
